import React from 'react';

const subredditSteps = [
    { icon: 'groups', title: '1. Enter Subreddit', description: 'Provide the name or URL of the subreddit you want to analyze.' },
    { icon: 'format_list_numbered', title: '2. Select Post Count', description: 'Choose the number of recent posts to fetch for analysis.' },
    { icon: 'downloading', title: '3. Get Posts', description: 'Fetch posts from the subreddit for pain point analysis.' }
];

const postSteps = [
    { icon: 'link', title: '1. Enter Post URL', description: 'Provide the direct URL of the Reddit post you want to analyze.' },
    { icon: 'downloading', title: '2. Get Post', description: 'Fetch the specific post for pain point analysis.' }
];

function HowTo({ searchType }) {
    const steps = searchType === 'subreddit' ? subredditSteps : postSteps;
    const subtitle = searchType === 'subreddit' 
        ? 'A simple 3-step process to discover opportunities in a subreddit.'
        : 'A simple 2-step process to discover opportunities in a specific post.';

    return (
        <div className="my-12">
            <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[var(--color-text-primary)] mb-4">How It Works</h2>
                <p className="text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto">{subtitle}</p>
            </div>
            <div className={`grid grid-cols-1 md:grid-cols-2 ${steps.length === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'} gap-8`}>
                {steps.map((step, index) => (
                    <div key={index} className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
                                <span className="material-symbols-outlined text-3xl">{step.icon}</span>
                            </div>
                            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">{step.title}</h3>
                        </div>
                        <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">{step.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default HowTo;
